module.exports = __webpack_public_path__ + "img/step10.ce3eeb60.png";